import { EmptyState, EmptyStateSuccessIllustration } from '@ardoq/status-ui';
import styled from 'styled-components';
import { FlexBox } from '@ardoq/layout';
import { PropsWithChildren, ReactNode } from 'react';

type ViewpointBuilderSidebarEmptyProps = PropsWithChildren<{
  title: string;
  description: string;
  media?: ReactNode;
}>;

const ViewpointBuilderSidebarEmptyState = ({
  title,
  description,
  children,
  media = <EmptyStateSuccessIllustration />,
}: ViewpointBuilderSidebarEmptyProps) => (
  <Container padding="large" align="center" height="full">
    <EmptyState
      layout="vertical"
      media={media}
      title={title}
      description={description}
    >
      {children}
    </EmptyState>
  </Container>
);

const Container = styled(FlexBox)`
  /* Limit width to prevent the description from "un-wrapping" to fewer lines.
     This keeps it nice, tidy and centered */
  max-width: 334px;
`;

export { ViewpointBuilderSidebarEmptyState };
